import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaUserCircle, FaCog, FaPlay, FaDownload, FaSpinner } from 'react-icons/fa';
import { generateAudio } from '../../api/api';
import './PdfUpload.css';
import './Audiogeneration.css';

const Audiogeneration = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    translatedLessons = [],
    selectedLanguage = '',
    selectedOptions = [],
    completedSteps = [],
    fileName = '',
    selectedLessons = [],
    currentStep = '',
    stepFlow = [],
    userEmail = 'Eezeelearn@gmail.com',
    autoGenerate = false, // ✅ NEW
  } = location.state || {};

  const [audioURLs, setAudioURLs] = useState([]);
  const [loadingStates, setLoadingStates] = useState([]);


  const handleSignOut = () => {
    navigate(`/signin`);
  };

  useEffect(() => {
    setAudioURLs(new Array(translatedLessons.length).fill(null));
    setLoadingStates(new Array(translatedLessons.length).fill(false));

    if (autoGenerate && translatedLessons.length > 0) {
      translatedLessons.forEach((_, index) => {
        handleGenerateAudio(index);
      });
    }
  }, [autoGenerate, translatedLessons]);



  const handleGenerateAudio = async (index) => {
    // Set loading true for this index
    setLoadingStates((prev) => {
      const updated = [...prev];
      updated[index] = true;
      return updated;
    });

    try {
      const audioUrl = await generateAudio(
        translatedLessons[index].content,
        selectedLanguage
      );

      console.log("Generated Audio URL:", audioUrl);

      // ? Add this check right here
      if (!audioUrl.startsWith('http')) {
        audioUrl = `${window.location.origin}/${audioUrl}`;
      }

      // Store the audio URL
      {/* const newAudioURLs = [...audioURLs];
    newAudioURLs[index] = audioUrl;
    setAudioURLs(newAudioURLs); */}

      //changes in url
      setAudioURLs(prev => {
        const updated = [...prev];
        updated[index] = audioUrl;
        return updated;
      });
      // audio files passes in frontend only unique id and audio path
      //selectedLessons(prevLessons => {
      //const updatedLessons = [...prevLessons];
      //updatedLessons[index] = {
      //...updatedLessons[index],
      //audio_path,
      //unique_id
      //};
      //return updatedLessons;
      //});
      selectedLessons[index] = {
        ...selectedLessons[index],
        audioPath: audioUrl, // ✅ Store actual path for video generation
      };

    } catch (error) {
      console.error('Failed to generate audio:', error);
    } finally {
      // Set loading false for this index
      setLoadingStates((prev) => {
        const updated = [...prev];
        updated[index] = false;
        return updated;
      });
    }
  };



  {/*
    const handleDownload = async (index) => {
    try {
      const audioUrl =
        audioURLs[index] ||
        (await generateAudio(translatedLessons[index].content, selectedLanguage));

      // ? Fix for relative path: prepend domain if missing
      //if (!audioUrl.startsWith('http')) {
      //audioUrl = `${window.location.origin}/${audioUrl}`;
      //}



      const link = document.createElement('a');
      link.href = audioUrl;
      //link.download = `${translatedLessons[index].title}_${selectedLanguage}.mp3`;
      //link.click(); 
      link.setAttribute('download', `${translatedLessons[index].title}_${selectedLanguage}.mp3`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Failed to download audio:', error);
    }
  };

  */}

  const handleDownload = async (index) => {
    try {
      // Ensure audio is generated
      let audioUrl = audioURLs[index];
      if (!audioUrl) {
        audioUrl = await generateAudio(translatedLessons[index].content, selectedLanguage);
        // Fix for relative path: prepend domain if missing
        if (!audioUrl.startsWith('http')) {
          audioUrl = `${window.location.origin}/${audioUrl}`;
        }
        // Save to state for future use
        setAudioURLs(prev => {
          const updated = [...prev];
          updated[index] = audioUrl;
          return updated;
        });
      }

      // Create a download link
      const link = document.createElement('a');
      link.href = audioUrl;
      // FIX: Use correct syntax for setAttribute
      link.setAttribute('download', `${translatedLessons[index].title}_${selectedLanguage}.mp3`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Failed to download audio:', error);
    }
  };

  {/* const handlePlay = (index) => {
    const audioElem = document.getElementById(`audio-player-${index}`);
    if (audioElem) {
      audioElem.currentTime = 0;
      audioElem.play();
    }
  };
*/}

  return (
    <div className="page-container">
      <div className="sidebar">
        <div className="sidebar-profile">
          <FaUserCircle className="sidebar-profile-icon" />
          <div className="sidebar-profile-name">{userEmail}</div>
        </div>

        <div className="sidebar-menu">
          <div className="sidebar-item">My Projects</div>
          <div className="sidebar-item" onClick={() => navigate('/upload')}>New Project</div>
          <div className="sidebar-section">
            <div className="sidebar-item section-title">{fileName}</div>
            <div className="sidebar-submenu">
              <div className="sidebar-subitem enabled completed">PDF Upload</div>
              {stepFlow.map((step, index) => (
                <div
                  key={index}
                  className={`sidebar-subitem enabled  ${completedSteps.includes(step) ? 'completed' : ''} 
      ${step === currentStep ? 'current-step' : ''} 
      enabled`}>
                  {step}
                </div>
              ))}
            </div>
          </div>
          <div className="sidebar-item">
            <FaCog style={{ marginRight: '8px' }} /> Settings
          </div>
        </div>

        <div className="sidebar-footer">
          <button className="sidebar-logout-btn" onClick={handleSignOut}>Sign out</button>
        </div>
      </div>

      {/* Audio Container */}
      <div className="audio-container">
        <div className="audio-columns">
          {/* Left: Original Lessons */}
          <div className="audio-col">
            <h4 className="audio-heading">Selected Lessons</h4>
            {selectedLessons.map((lesson, index) => (
              <div key={index} className="audio-box original-box">
                <div className="audio-title">{lesson.title}</div>
                <p className="audio-text">{lesson.content}</p>
              </div>
            ))}
          </div>

          {/* Right: Translated + Audio */}
          <div className="audio-col">
            <h4 className="audio-heading">Generate Audio ({selectedLanguage})</h4>
            {translatedLessons.map((lesson, index) => (
              <div key={index} className="audio-box translated-box">
                <div className="audio-header">
                  <div className="audio-title">{lesson.title}</div>

                  <div className="audio-controls">
                    {/* <button className="icon-btn" onClick={() => handleGenerateAudio(index)}>
                    <FaPlay />
                  </button> */}
                    <button className="icon-btn" onClick={() => handleDownload(index)}>
                      <FaDownload />
                    </button>
                  </div>
                </div>
                {loadingStates[index] ? (
                  <div className="audio-loading">  <FaSpinner className="spinner-icon" /> Generating audio...</div>
                ) : (
                  audioURLs[index] && (

                    <audio
                      id={`audio-player-${index}`}
                      controls
                      src={audioURLs[index]}
                      style={{ width: '100%' }}
                    />

                  )
                )}

                <p className="audio-text">{lesson.content}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="footer-buttons">
          <button className="action-btn" onClick={() => navigate(-1)}>Back</button>
          <button className="action-btn" onClick={() => navigate('/videogeneration', {
            state: {
              translatedLessons,
              selectedLessons,
              selectedLanguage,
              stepFlow,
              completedSteps,
              completedSteps: [...completedSteps, 'Translation'],
              currentStep: 'Video Generation',
              userEmail,
              fileName
            }
          })}> Next</button>
        </div>
      </div>
    </div>
  );
};


export default Audiogeneration;
